import { TopicWithSummary } from "../../imsdk/api/topic";

import time from "../../imsdk/time";
import * as ImSdk from "../../imsdk/api";
import { FriendBlack } from "../../imsdk/db/t_friend_black";
import { User } from "../../imsdk/db/t_user";
import { buildSignalTopicId, isGroupTopic } from "../utils/utils";
import { UserState } from "./UserStore";

export function batchUpdateObjArr<T>(source: T[], merge: T[], key: keyof T) {
    for (let i = 0; i < merge.length; i++) {
        for (let j = 0; j < source.length; j++) {
            if (source[j][key] === merge[i][key]) {
                source[j] = { ...source[j], ...merge[i] };
                // console.log('>>>>>>>>> mergethis');
                break;
            }
        }
    }

    return [...source];
}

export type TopicSummaryStat = {
    top: TopicWithSummary[];
    normal: TopicWithSummary[];
};

export function replace_topic_summary(
    topicSummaryList: TopicSummaryStat
): TopicSummaryStat {
    topicSummaryList.top.sort(compareTopic());
    topicSummaryList.normal.sort(compareTopic());
    return { ...topicSummaryList };
}

export function clean_msg_by_tid(
    stat: TopicSummaryStat, // 当前存储的数据
    tid: string // 事件来的新数据
): boolean {
    const idx1 = stat.top.findIndex((item) => {
        return tid === item.topic.tid;
    });
    if (idx1 >= 0) {
        const summary = stat.top[idx1].summary;
        if (summary) {
            summary.unreadCnt = 0;
            summary.latest = undefined;
            summary.latestAt = undefined;
            summary.latestVisibleMsg = undefined
        }
        return true;
    }
    const idx2 = stat.normal.findIndex((item) => {
        return tid === item.topic.tid;
    });
    if (idx2 >= 0) {
        const summary = stat.normal[idx2].summary
        if (summary) {
            summary.unreadCnt = 0;
            summary.latest = undefined;
            summary.latestAt = undefined;
            summary.latestVisibleMsg = undefined
        }
        return true;
    }
    return false;
}
export function delete_user_summary(state: UserState, uid: number): boolean {
    const currentUid = ImSdk.getInstance().CurrentUid()
    const tid = buildSignalTopicId(currentUid, uid)
    let topChange = false;
    let normalChange = false;
    let contactChange = false;
    let blackChange = false;
    const idx1 = state.topicSummaryList.top.findIndex((item) => {
        return tid === item.topic.tid;
    });
    if (idx1 >= 0 && idx1 < state.topicSummaryList.top.length) {
        topChange = true
        state.topicSummaryList.top.splice(idx1, 1);
    }
    const idx2 = state.topicSummaryList.normal.findIndex((item) => {
        return tid === item.topic.tid;
    });

    if (idx2 >= 0 && idx2 < state.topicSummaryList.top.length) {
        normalChange = true
        state.topicSummaryList.normal.splice(idx2, 1);
    }

    const idx3 = state.contactList.findIndex((item) => {
        return uid === item.uid;
    });
    if (idx3 >= 0 && idx3 < state.contactList.length) {
        contactChange = true
        state.contactList.splice(idx3, 1);
    }
    const idx4 = state.contactBlackList.findIndex((item) => {
        return uid === item.uid;
    });
    if (idx4 >= 0 && idx4 < state.contactBlackList.length) {
        blackChange = true
        state.contactBlackList.splice(idx4, 1);
    }
    return topChange || normalChange || contactChange || blackChange
}
export function update_user(user: User, contactList: User[]): boolean {
    let isChange = false;
    const index = contactList.findIndex(v => v.uid === user.uid)
    if (index >= 0) {
        contactList[index] = user
        isChange = true
    }
    return isChange
}
export function update_user_remark(uid: number, remark: string, tids: string[], state: UserState): boolean {
    let isChange = false;
    const index = state.contactList.findIndex(v => v.uid === uid)
    if (index >= 0) {
        state.contactList[index].remark = remark
        isChange = true
    }
    state.topicSummaryList.top.filter((item) => tids.includes(item.topic.tid)).forEach(item => {
        if (!isGroupTopic(item.topic.tid)) {
            item.topic.name = remark
            isChange = true
        } else {
            if (item.users) {
                const index = item.users.findIndex(v => v.uid === uid)
                if (index >= 0) {
                    item.users[index].remark = remark
                    item.users = [...item.users]
                    isChange = true
                }
            }
        }

    })
    state.topicSummaryList.normal.filter((item) => tids.includes(item.topic.tid)).forEach(item => {
        if (!isGroupTopic(item.topic.tid)) {
            item.topic.name = remark
            isChange = true
        } else {
            if (item.users) {
                const index = item.users.findIndex(v => v.uid === uid)
                if (index >= 0) {
                    item.users[index].remark = remark
                    item.users = [...item.users]
                    isChange = true
                }
            }
        }
    })
    return isChange
}
export function update_user_avatar(uid: number, avatar: string, tids: string[], state: UserState): boolean {
    let isChange = false;
    const index = state.contactList.findIndex(v => v.uid === uid)
    if (index >= 0) {
        state.contactList[index].avatar = avatar
        isChange = true
    }

    state.topicSummaryList.top.filter((item) => tids.includes(item.topic.tid)).forEach(item => {
        if (!isGroupTopic(item.topic.tid)) {
            if (item.summary && item.summary.avatarList) {
                const name = item.summary?.avatarList.name
                item.summary.avatarList = { name: name, avatar: avatar, uid: item.topic?.uid || 0 }
                isChange = true
            }
        } else {
            if (item.users) {
                const index = item.users.findIndex(v => v.uid === uid)
                if (index >= 0) {
                    item.users[index].avatar = avatar
                    item.users = [...item.users]
                    isChange = true
                }
            }
        }
    })
    state.topicSummaryList.normal.filter((item) => tids.includes(item.topic.tid)).forEach(item => {
        if (!isGroupTopic(item.topic.tid)) {
            if (item.summary && item.summary.avatarList) {
                const name = item.summary?.avatarList.name
                item.summary.avatarList = { name: name, avatar: avatar, uid: item.topic?.uid || 0 }
                isChange = true
            }
        } else {
            if (item.users) {
                const index = item.users.findIndex(v => v.uid === uid)
                if (index >= 0) {
                    item.users[index].avatar = avatar
                    item.users = [...item.users]
                    isChange = true
                }
            }
        }
    })

    return isChange
}
export function upsert_topic_summary(
    stat: TopicSummaryStat, // 当前存储的数据
    topics: TopicWithSummary[], // 事件来的新数据
    upsert: boolean // 新会话是否插入
): boolean {
    // console.log("====upsert_topic_summary", stat, topics, upsert);
    let topChange = false;
    let normalChange = false;
    const n = topics.length;
    for (let i = 0; i < n; i++) {
        const t = topics[i];
        // 在当前的viewList找找，没找到就增加，找到就更新
        const idx1 = stat.top.findIndex((item) => {
            return t.topic.tid === item.topic.tid;
        });
        if (idx1 >= 0 && idx1 < stat.top.length) {
            if (t.topic.order > 0) {
                stat.top[idx1] = t;
                topChange = true;
            } else {
                // 已经不再置顶
                stat.top.splice(idx1, 1);
                topChange = true;
                normalChange = true;
                stat.normal.push(t);
            }
        } else {
            const idx2 = stat.normal.findIndex((item) => {
                return t.topic.tid === item.topic.tid;
            });
            if (idx2 >= 0 && idx2 < stat.normal.length) {
                if (t.topic.order <= 0) {
                    stat.normal[idx2] = t;
                    normalChange = true;
                } else {
                    // 变成了置顶
                    stat.normal.splice(idx2, 1);
                    normalChange = true;
                    stat.top.push(t);
                    topChange = true;
                }
            } else if (upsert && t.group?.flag !== 2) {
                if (t.topic.order > 0) {
                    const top = stat.top
                    top.push(t);
                    stat.top = [...top]
                    topChange = true;
                } else {
                    const normal = stat.normal
                    normal.push(t);
                    stat.normal = [...normal];
                    normalChange = true;
                }
            }
        }
    }
    topChange && stat.top.sort(compareTopic());
    normalChange && stat.normal.sort(compareTopic());

    return topChange || normalChange;
}
export function upsert_topic_group() {
    // if (isGroupTopic(t.topic.tid)) {
    // ImSdk.getInstance().GroupSummaryUpdate(t.topic.tid, {
    //         name: t.topic.name,
    //         avatar: t.summary?.avatarList.avatar,
    //         remark: t.topic.remark
    //     }).then()
    // }
}
export function upsert_topic_draft(
    stat: TopicSummaryStat, // 当前存储的数据
    tid: string,
    draft: string
): boolean {
    let topChange = false;
    let normalChange = false;
    // 在当前的viewList找找，没找到就增加，找到就更新
    const idx1 = stat.top.findIndex((item) => {
        return tid === item.topic.tid;
    });
    if (idx1 >= 0 && idx1 < stat.top.length) {
        const topic = stat.top[idx1]
        if (topic.topic.draft !== draft) {
            topic.topic.draft = draft
            stat.top[idx1] = topic;
            topChange = true
        }
    } else {
        const idx2 = stat.normal.findIndex((item) => {
            return tid === item.topic.tid;
        });
        if (idx2 >= 0 && idx2 < stat.normal.length) {
            const topic = stat.normal[idx2]
            if (topic.topic.draft !== draft) {
                topic.topic.draft = draft
                stat.normal[idx2] = topic;
                normalChange = true
            }
        }
    }
    return topChange || normalChange;
}
export function del_topic(
    stat: TopicSummaryStat, // 当前存储的数据
    tid: string, // 事件来的新数据
): TopicSummaryStat {
    // 在当前的viewList找找，没找到就增加，找到就更新
    const top = stat.top.filter((item) => {
        return tid !== item.topic.tid;
    });

    const normal = stat.normal.filter((item) => {
        return tid !== item.topic.tid;
    });
    return { top, normal }
}

// function compareTopicFunc(
//     uid: number
// ): (a: TopicWithSummary, b: TopicWithSummary) => number {
//     return (a: TopicWithSummary, b: TopicWithSummary): number => {
//         return -_compare_topic(uid, a, b);
//     };
// }


function compareTopic(): (a: TopicWithSummary, b: TopicWithSummary) => number {
    return (a: TopicWithSummary, b: TopicWithSummary): number => {
        return -_compare_topic(a, b);
    };
}

// 会话排序
// 1分钟内按访问时间排序
// function _compare_topic(
//     uid: number,
//     a: TopicWithSummary,
//     b: TopicWithSummary
// ): number {
//     {
//         const stimeExp = time.toUnixMillSecond(
//             time.add(time.now(), -20 * time.MINUTE)
//         );
//         // 1.有消息的会话优先级最高，没消息的会话（空会话）优先级最低
//         // 2.对于有消息的会话，最后一条消息是自己发送的且发送时间是20分钟以内优先级最高
//         const s1 = a.summary?.latest;
//         const s2 = b.summary?.latest;
//         if (s1 && s2) {
//             if (s1.sender === uid && s2.sender === uid) {
//             } else if (s1.sender === uid && s1.stime > stimeExp) {
//                 return 1;
//             } else if (s2.sender === uid && s2.stime > stimeExp) {
//                 return -1;
//             } else {
//             }
//         } else if (s1) {
//             return 1;
//         } else if (s2) {
//             return -1;
//         } else {
//         }
//     }

//     // 置顶优先级最高
//     if (a.topic.order > 0 && b.topic.order > 0) {
//         // return a.topic.order - b.topic.order;
//     } else if (a.topic.order > 0 && b.topic.order <= 0) {
//         return 1;
//     } else if (a.topic.order <= 0 && b.topic.order > 0) {
//         return -1;
//     }

//     const exp = time.toUnixMillSecond(time.add(time.now(), -2 * time.MINUTE));
//     // 最近2分钟访问过的优先级最大，因为10分钟内访问过，大概率还会再进去，只要10分钟内访问过优先级是一致
//     if (a.topic.lvTime >= exp && b.topic.lvTime >= exp) {
//         return 0;
//     } else if (a.topic.lvTime >= exp && b.topic.lvTime < exp) {
//         return 1;
//     } else if (a.topic.lvTime < exp && b.topic.lvTime >= exp) {
//         return -1;
//     }

//     // 已读的优先 只要有未读的消息，不管数量
//     const c1 = a.summary?.unreadCnt || 0;
//     const c2 = b.summary?.unreadCnt || 0;
//     if (c1 > 0 && c2 > 0) {
//         // 比较消息的接收时间 都有未读 优先级一样
//         // const s1 = a.summary?.latest?.stime || 0;
//         // const s2 = b.summary?.latest?.stime || 0;
//         // return s1 > s2 ? 1 : -1;
//     } else if (c1 > 0 && c2 <= 0) {
//         return 1;
//     } else if (c1 <= 0 && c2 > 0) {
//         return -1;
//     }

//     const s1 = a.summary?.latest?.stime || 0;
//     const s2 = b.summary?.latest?.stime || 0;
//     if (s1 !== s2) {
//         return s1 > s2 ? 1 : -1;
//     }

//     // 会话的创建时间
//     if (a.topic.ctime > b.topic.ctime) {
//         return 1;
//     } else if (a.topic.ctime < b.topic.ctime) {
//         return -1;
//     }

//     // 会话的本地更新时间
//     if (a.topic.lutime > b.topic.lutime) {
//         return 1;
//     } else if (a.topic.lutime < b.topic.lutime) {
//         return -1;
//     }

//     return 0;
// }

// function compareTopicFunc(
//     uid: number
// ): (a: TopicWithSummary, b: TopicWithSummary) => number {
//     return (a: TopicWithSummary, b: TopicWithSummary): number => {
//         return -_compare_topic(uid, a, b);
//     };
// }


function _compare_topic(
    a: TopicWithSummary,
    b: TopicWithSummary
): number {
    // 置顶优先级最高
    if (a.topic.order > 0 && b.topic.order > 0) {
        return a.topic.order - b.topic.order;
    } else if (a.topic.order > 0 && b.topic.order <= 0) {
        return 1;
    } else if (a.topic.order <= 0 && b.topic.order > 0) {
        return -1;
    }
    const exp = time.toUnixMillSecond(time.add(time.now(), -2 * time.MINUTE));
    // 最近2分钟访问过的优先级最大，因为10分钟内访问过，大概率还会再进去，只要10分钟内访问过优先级是一致
    // if (a.topic.lvTime >= exp && b.topic.lvTime >= exp) {
    //     return 0;
    // } else if (a.topic.lvTime >= exp && b.topic.lvTime < exp) {
    //     return 1;
    // } else if (a.topic.lvTime < exp && b.topic.lvTime >= exp) {
    //     return -1;
    // }

    const s1 = a.summary?.latestVisibleMsg?.stime || 0;
    const s2 = b.summary?.latestVisibleMsg?.stime || 0;

    if (s1 !== s2) {
        return s1 > s2 ? 1 : -1;
    }

    // 会话的创建时间
    if (a.topic.ctime > b.topic.ctime) {
        return 1;
    } else if (a.topic.ctime < b.topic.ctime) {
        return -1;
    }

    // 会话的本地更新时间
    if (a.topic.lutime > b.topic.lutime) {
        return 1;
    } else if (a.topic.lutime < b.topic.lutime) {
        return -1;
    }

    return 0;
}

export async function GetContactList(): Promise<{ error: any, contacts?: User[] }> {
    const r = await ImSdk.getInstance().GetContact({ isfriend: 1 })
    if (r.users && r.users.length > 0) {
        return { error: r.error, contacts: r.users }
    }
    return { error: r.error }
}

export async function qryContactBlackList(): Promise<{ error: any, blacks?: FriendBlack[] }> {
    return ImSdk.getInstance().GetFriendBlack()
}

export function handelBlack(blacks: FriendBlack[], uid: number, black: string, time: number) {
    if (black === "1") {
        const arr: FriendBlack[] = [];
        if (blacks) {
            arr.push(...blacks);
        }
        arr.push({ uid, black, lutime: time, lctime: time });
        return arr;
    } else {
        return blacks?.filter((v) => uid != v.uid);
    }
}
